const About = {
  name: 'TechCycle.me',
  description: 'Personal blog on tech',
  version: '3.0',
  link: 'https://www.techcycle.me',
  by: {
    mjunaidi: 'https://mjunaidi.github.io',
    devTools: 'https://www.mjunaidi.com',
    github: 'https://github.com/mjunaidi',
    linkedIn: 'https://www.linkedin.com/in/m-junaidi-963983143',
  },
  email: 'trendcycle@yahoo.com',
  country: 'Malaysia',
  poweredBy: [
    {
      'React': 'https://reactjs.org',
    },
    {
      'Ant Design': 'https://ant.design',
    },
  ],
}

export default About
